module.exports = __webpack_public_path__ + "img/feature-tile-icon-03.21edf48b.svg";